import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-8 font-serif">
      <div className="container mx-auto flex justify-center items-center">
         <div className="flex flex-col items-center space-y-4">
          <p className="text-xl">Email: elena.barker.cyf@gmail.com</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
